<script>
import ViewTitle from '@/components/ViewTitle'
import WideIconTile from '@/components/WideIconTile'
import Button from '@/components/Button'
import CovidPDFUtils from '@/utils/covidPDFUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import FileUtils from '@/utils/fileUtils'

export default
{
    name: 'generate-covid-certificate',

    created ()
    {
        const userQuery = this.$route.query.user
        if (!userQuery) throw new Error('No user query provided')

        this.user = JSON.parse(userQuery)
    },

    render () 
    {
        return (
            <div id='generate-covid-certificate-view'>
                <view-title>Quelle est la raison de votre sortie ?</view-title>
                <wide-icon-tile title='Déplacements entre le domicile et le lieu d’exercice de l’activité professionnelle' on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.TRAVAIL)} />
                <wide-icon-tile title='Déplacements/transits ferroviaires, aériens ou bus pour longues distances' on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.TRANSITS)} />
                <wide-icon-tile title="Déplacements brefs, dans la limite d'une heure quotidienne et dans un rayon maximal d'un kilomètre autour du domicile pour
                    les besoins des animaux de compagnie" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.ANIMAUX)} />
                <wide-icon-tile title="Déplacements pour motif familial impérieux, assistance et garde d'enfants" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.FAMILLE)} />
                <wide-icon-tile title='Consultations, examens, soins et achat de médicaments' on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.SANTE)} />
                <wide-icon-tile title='Déplacement des personnes en situation de handicap et de leur accompagnant' on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.HANDICAP)} />
                <wide-icon-tile title='Convocation judiciaire ou administrative pour se rendre dans un service public' on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.JUDICIAIRE)} />
                <wide-icon-tile title="Participation à des missions d'intérêt général sur demande de l'autorité administrative" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.MISSIONS)} />
                <div class='subtitle'>Motifs uniquement de 6h à 18h le week-end</div>
                <wide-icon-tile title="Effectuer des achats de première nécessité" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.COURSES)} />
                <wide-icon-tile title="Activité sportive individuelle" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.SPORT)} />
                <wide-icon-tile title="Déplacement à destination ou en provenance d'un lieu de culte" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.RASSEMBLEMENT)} />
                <wide-icon-tile title="Se rendre dans un service public" on-click={() => this.onReasonChosen(CovidPDFUtils.REASONS.DEMARCHE)} />
                <Button text='Supprimer ce modèle' type='danger' on-click={this.onDeleteModelClicked} />
            </div>
        )
    },

    data () 
    {
        return {
            user: null,
            reason: null
        }
    },

    mounted ()
    {
    },

    methods:
    {
        async onReasonChosen (reason)
        {
            window.app.showFullscreenSpinner = true
            
            this.$router.push('/covid')

            const pdfBlob = await CovidPDFUtils.generatePdf(this.user, [reason])
            await FileUtils.writeFileToDownloadsAsync(`Attestation de déplacement ${this.user.firstName} ${this.user.lastName} ${new Date().toISOString()}.pdf`, pdfBlob)

            window.app.showFullscreenSpinner = false
        },

        onDeleteModelClicked ()
        {
            const models = LocalStorageUtils.covidCertificateTemplates
            models.splice(models.indexOf(this.user))
            LocalStorageUtils.covidCertificateTemplates = models

            this.$router.push('/covid')
        }
    },

    components:
    {
        ViewTitle,
        WideIconTile,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#generate-covid-certificate-view
{
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnDesktop({
        margin-top: 4vw;
        margin-left: 10vw;
        margin-right: 10vw;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .wide-icon-tile
    {
        margin-bottom: 10px;

        > .middle > .title
        {
            font-weight: 500;
        }
    }

    .subtitle
    {
        font-size: 17px;
        margin-top: 10px;
        font-weight: bold;
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/GenerateCovidCertificate.vue